/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var GetComplianceByObject = require('../services/GetComplianceByObject');
var SecExamInvInqSectionComplianceView = require('../views/SecExamInvInqSectionComplianceView');

module.exports = {
  channel: 'sc',

  event: 'build:exam-inv-inq-section-compliance-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: buildComplianceView(data)
    });
  }
};

function buildComplianceView(data) {
  var deferred = $.Deferred();

  GetComplianceByObject({ objectId: data.objectId, objectTypeId: data.objectTypeId })
    .done(function(compliances) {
      deferred.resolve(
        new SecExamInvInqSectionComplianceView({
          model: new Backbone.Model({
            objectId: data.objectId,
            objectTypeId: data.objectTypeId
          }),
          collection: new PageableCollection(compliances, { pageSize: 25 })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
